import React, { useMemo } from 'react'

import Field from '../../../../../../../../components/Form/Field'

import { NAME, RIGHT_TYPE, RIGHT_TYPE_DIGITAL, RIGHT_TYPE_POSTS } from '../../../../fields'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

function AdvancedNameSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { values } = formik

  const sectionTitle = useMemo(() => {
    switch (values[RIGHT_TYPE]) {
      case RIGHT_TYPE_DIGITAL:
        return 'Campaign name'
      case RIGHT_TYPE_POSTS:
        return 'Report name'
      default:
        return 'Name'
    }
  }, [values])

  const fieldPlaceholder = useMemo(() => {
    switch (values[RIGHT_TYPE]) {
      case RIGHT_TYPE_DIGITAL:
        return 'Name of campaign'
      case RIGHT_TYPE_POSTS:
        return 'Name of report'
      default:
        return 'Name'
    }
  }, [values])

  return (
    <section className={drawerFormClasses.section}>
      <div className={drawerFormClasses.tabsContainer}>
        <h3 className={drawerFormClasses.sectionTitle}>{sectionTitle}</h3>
      </div>
      <Field
        placeholder={fieldPlaceholder}
        formik={formik}
        name={NAME}
        enableReinitialize
        autoComplete="off"
        disablePlaceholderFormatting
      />
    </section>
  )
}

export default AdvancedNameSection
